// Sentral konfigurasjon for nedtelling og bestillingsprogresjon.
// Oppdater disse verdiene når status endrer seg.
export const LAUNCH_DATE = "2026-08-01T00:00:00+02:00";
export const ORDERS_CURRENT = 4;
export const ORDERS_GOAL = 10;

export const isCountdownActive = (): boolean => {
  if (ORDERS_CURRENT >= ORDERS_GOAL) return false;
  return new Date(LAUNCH_DATE).getTime() > Date.now();
};
